export enum ReapproState {
  CREATED = 'created',
  PENDING_PREPARATION = 'pending_preparation',
  SHIPPED = 'shipped',
  RECEIVED = 'received',
  IN_PREPARATION = 'in_preparation',
  REFUSED = 'refused',
}

export const ReapproStateTranslation: Record<ReapproState, string> = {
  [ReapproState.CREATED]: 'Créé',
  [ReapproState.PENDING_PREPARATION]: 'En attente de préparation',
  [ReapproState.SHIPPED]: 'Expédiée',
  [ReapproState.RECEIVED]: 'Réceptionnée',
  [ReapproState.IN_PREPARATION]: 'En cours de préparation',
  [ReapproState.REFUSED]: 'Refusée',
};
